import { ProductTypes } from "../productCommons.js";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const findVal = (
  object: Record<string, unknown>,
  key: string,
): Record<string, unknown> | undefined => {
  let value;
  Object.keys(object).some((k) => {
    if (k === key) {
      value = object[k];
      return true;
    }
    const objectValue = object[k];
    if (isRecord(objectValue)) {
      value = findVal(objectValue, key);
      return value !== undefined;
    }
  });
  return value;
};

/**
 * @deprecated use getDisplayNameByKey
 */
export const getProductDisplayNameByKey = (key: string) => {
  const object = findVal(ProductTypes, key);

  return object?.display as string | undefined;
};
